module.exports = __webpack_public_path__ + "img/icons_31.06bd1062.png";